import {
  BenchmarkStatsDataType,
  IndustryCategoryComparisonStatsType,
} from "@redotech/account-common/industry-comparison-stats";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const comparisonStatisticValue = z.number().optional();

const comparisonStatistic = z.object({
  title: z.string(),
  merchantValue: comparisonStatisticValue,
  industryValue: comparisonStatisticValue,
  type: createEnum(BenchmarkStatsDataType),
  lowerIsBetter: z.boolean(),
});

export const getIndustryCategoryComparisonStats = {
  name: "getIndustryCategoryComparisonStats" as const,
  input: z.object({
    teamId: z.string(),
    categoryId: z.optional(z.string()),
    dateRange: z.object({ startDate: z.date(), endDate: z.date() }),
  }),
  output: z.object({
    statistics: z.record(
      createEnum(IndustryCategoryComparisonStatsType),
      comparisonStatistic,
    ),
  }),
};
